module.exports = __webpack_public_path__ + "ae5788784606a1e435306f94c9f90067.svg";